import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './app/environments/environment';

const bigIdScript = document.createElement('script');
bigIdScript.src = `https://bigidcmp.cloud/banner.js?siteId=${environment.bigIdSiteId}`;
bigIdScript.async = false;
document.head.appendChild(bigIdScript);

if (environment.bigIdConsentConfig) {
  (window as any).BigIDConsentConfig = environment.bigIdConsentConfig;
  const eventsScript = document.createElement('script');
  eventsScript.src = 'https://www.kemper.com/sites/default/files/scripts/common/bigid-events.js';
  eventsScript.async = false;
  document.head.appendChild(eventsScript);
}

bootstrapApplication(App, appConfig)
  .catch((err) => {
    const sanitizedMessage = (err?.message || 'Unknown error').replace(/[\r\n]/g, ' ');
    console.error('Application bootstrap failed:', sanitizedMessage);
  });
